class SectionAnimator {

    constructor(className) {
        this.sections = document.getElementsByClassName(className);
    }

    #observerHandler(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('scrolled-into-view');
            }
        });
    }

    animate() {
        const observer = new IntersectionObserver(this.#observerHandler);
        Array.from(this.sections).forEach((section, index) => {
            if (index !== 0) {
                observer.observe(section);
            }
        });

    }
}
const section = new SectionAnimator('backgrounded-item');
section.animate();